// extracted by mini-css-extract-plugin
module.exports = {"productContent":"style_productContent__k_Q52","isDrawer":"style_isDrawer__ubv4Y"};